module.exports = __webpack_public_path__ + "70f8eb0b3d744a970ecc4570598fc1a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/syncOffline.png
// module id = 115
// module chunks = 0